import { pxToRem } from './remConversion'

// ─── Button ────────────────────────────────────────────────────────────────

export const getButtonColor = (theme: any, themeCustom: any, isPhotobooth = false): string => {
  const color = themeCustom ? themeCustom.details.buttons.color : theme.button_color || '#34b076'
  if (isPhotobooth) {
    return themeCustom ? themeCustom.details.buttons.color : theme.photobooth_button_color || color
  }
  return color
}

export const getButtonRadius = (theme: any, themeCustom: any): string => {
  return pxToRem(themeCustom ? themeCustom.details.buttons.radius : theme.button_radius || 0)
}

export const getButtonTextColor = (theme: any, isPhotobooth = false): string => {
  if (isPhotobooth) {
    return theme.photobooth_button_text_color || theme.button_text_color || 'white'
  }
  return theme.button_text_color || 'white'
}

// ─── Typography ────────────────────────────────────────────────────────────

export const getTextFont = (theme: any, themeCustom: any): string => {
  return themeCustom ? themeCustom.details.textes.fontFamily : theme.text_font || 'Open Sans'
}

export const getTitleFont = (theme: any, themeCustom: any): string => {
  return themeCustom ? themeCustom.details.titles.fontFamily : theme.title_font || 'Nunito'
}

export const getSubtitleFont = (theme: any, themeCustom: any): string => {
  return themeCustom ? themeCustom.details.titles.fontFamily : theme.subtitle_font || theme.title_font || 'Nunito'
}

export const getBodyTextColor = (theme: any, themeCustom: any): string => {
  return themeCustom ? themeCustom.details.textes.colors.text : theme.text_color || 'black'
}

export const getTitleColor = (
  theme: any,
  themeCustom: any,
  level: 'title' | 'h2' | 'h3' = 'title'
): string => {
  if (themeCustom) return themeCustom?.details?.titles?.colors?.[level] || '#000000'
  return theme.title_color || '#000000'
}

// ─── Surfaces / Backgrounds ────────────────────────────────────────────────

export const getBodyBgColor = (theme: any, themeCustom: any): string => {
  return themeCustom?.details?.colors?.margins || theme.body_background_color || '#DDDDDD'
}

export const getCardBgColor = (theme: any, themeCustom: any): string => {
  return themeCustom ? themeCustom.details.colors.contents : theme.card_background_color || 'white'
}

export const getBannerColor = (theme: any, themeCustom: any): string => {
  return themeCustom ? themeCustom.details.colors.banner : theme.button_color || '#34b076'
}

export const getFooterBgColor = (theme: any, themeCustom: any): string => {
  return themeCustom
    ? themeCustom.details.colors.footer
    : theme.footer_background_color || theme.card_background_color || 'white'
}